module.exports = __webpack_public_path__ + "img/IDM.beb314b1.png";